<template>
<AppLayout>
  <div class="transaction">
    <section id="transaction-products">
        <div class="container-fluid">  
          <div class="d-flex justify-content-between align-items-center mb-1">
            <h6 class="fw-bold">Approvals Tracking (Awaiting Action)</h6>
          </div>

          <div class="mt-2">
            <div class="p-4 ">
              <table id="approvalsTable" class="table table-hover align-middle w-100">
                  <thead>
                      <tr>
                        <th>No.</th>
                        <th>Duration</th>
                        <th>Module</th>
                        <th>Ref / ID</th>
                        <th>Department</th>
                        <th>Amount</th>
                        <th>Requested By</th>
                        <th>Current Stage</th>
                        <th>Priority</th>
                        <th>Action</th>
                      </tr>
                  </thead>
              </table>
              <div v-if="loading && !dataTable" class="py-3">
                <div class="skeleton-table">
                  <div v-for="i in 5" :key="i" class="skeleton-row mb-3">
                    <div class="skeleton-cell" style="width: 5%"></div>
                    <div class="skeleton-cell" style="width: 15%"></div>
                    <div class="skeleton-cell" style="width: 10%"></div>
                    <div class="skeleton-cell" style="width: 15%"></div>
                    <div class="skeleton-cell" style="width: 15%"></div>
                    <div class="skeleton-cell" style="width: 20%"></div>
                    <div class="skeleton-cell" style="width: 10%"></div>
                    <div class="skeleton-cell" style="width: 10%"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>

    <!-- Details Modal -->
    <Modal v-if="isModalVisible" @close="closeModal">
      <template v-slot:header>
        <h5 class="fw-bold mb-0">Approval Request Details</h5>
      </template>
      <template v-slot:body>
        <div class="p-2" v-html="getModalBody(modalApproval)"></div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-secondary px-4 text-13" @click="closeModal">Close</button>
      </template>
    </Modal>

    <PurchaseRequestDetailsModal
      v-if="showPurchaseRequestModal"
      :request="purchaseRequestDetails"
      @close="closeModal"
    />
  </div>
</AppLayout>
</template>

<script>
import AppLayout from '@/components/AppLayout.vue';
import Modal from '@/components/Modal.vue';
import PurchaseRequestDetailsModal from '@/components/PurchaseRequestDetailsModal.vue';
import axios from 'axios';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-responsive-bs5';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css';
import jszip from 'jszip';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

window.JSZip = jszip;
if (pdfMake && pdfFonts) {
  // eslint-disable-next-line no-import-assign
  pdfMake.vfs = pdfFonts.pdfMake ? pdfFonts.pdfMake.vfs : pdfFonts;
}

export default {
  name: 'ApprovalsAwaiting',
  components: {
    AppLayout,
    Modal,
    PurchaseRequestDetailsModal,
  },
  data: () => ({
    approvals: [],
    loading: false,
    token: JSON.parse(localStorage.getItem('access_token')),
    isModalVisible: false,
    modalApproval: null,
    showPurchaseRequestModal: false,
    purchaseRequestDetails: null,
    dataTable: null,
  }),
  methods: {
    async fetchAwaiting() {
      this.loading = true;
      try {
        const res = await axios.get(`${process.env.VUE_APP_URL}/approvals/awaiting-all`, {
          headers: { Authorization: `Bearer ${this.token}` }
        });
        this.approvals = res.data;
        this.reinitializeTable();
      } catch (e) {
        console.error('Failed to fetch awaiting approvals', e);
      } finally {
        this.loading = false;
      }
    },
    reinitializeTable() {
      if (this.dataTable) {
        this.dataTable.clear();
        this.dataTable.rows.add(this.preprocessData(this.approvals));
        this.dataTable.draw();
      } else {
        this.initializeDataTable();
      }
    },
    preprocessData(data) {
      return data.map((item, index) => {
        const amount = item.purchase?.amount || item.purchaseRequest?.totalAmount || 0;
        return {
          ...item,
          index: index + 1,
          durationHtml: this.renderDuration(item.durationText),
          moduleHtml: `<span class="text-capitalize text-13">${this.formatModuleName(item.module)}</span>`,
          referenceHtml: `<span class="fw-bold text-primary text-13">${this.getReference(item)}</span>`,
          departmentHtml: `<span class="text-13">${item.purchase?.Department?.name || item.purchaseRequest?.department || '-'}</span>`,
          amountHtml: `<span class="fw-bold text-13">${this.formatMoney(amount)}</span>`,
          requestedByHtml: `
            <div class="text-13">${item.requestedBy?.name || '-'}</div>
            <small class="text-muted" style="font-size: 10px;">${this.formatDate(item.createdAt, true)}</small>
          `,
          stageHtml: this.renderStage(item),
          priorityHtml: this.renderPriority(item.priority),
        };
      });
    },
    initializeDataTable() {
      if (this.dataTable) return;
      
      this.$nextTick(() => {
        this.dataTable = $('#approvalsTable').DataTable({
          data: this.preprocessData(this.approvals),
          columns: [
            { 
              data: null,
              render: (data, type, row, meta) => meta.row + meta.settings._iDisplayStart + 1
            },
            { data: 'durationHtml' },
            { data: 'moduleHtml' },
            { data: 'referenceHtml' },
            { data: 'departmentHtml' },
            { data: 'amountHtml' },
            { data: 'requestedByHtml' },
            { data: 'stageHtml' },
            { data: 'priorityHtml' },
            { 
              data: null, 
              render: (data, type, row) => {
                return `<button class="btn btn-default btn-view-details" style="border: 1px solid #333; font-size: 10px !important; border-radius: 12px; padding: 2px 12px;" data-id="${row.id}">View</button>`;
              }
            }
          ],
          language: {
            paginate: {
              previous: '<i class="fa fa-chevron-left"></i>',
              next: '<i class="fa fa-chevron-right"></i>',
            },
          },
          dom: '<"d-flex justify-content-between align-items-center mb-2"Bf>rtip',
          buttons: [
            {
              extend: 'collection',
              text: '<i class="fa fa-download me-1"></i> Export',
              className: 'btn btn-outline-dark btn-sm rounded-pill px-3',
              buttons: [
                { extend: 'copy', className: 'dropdown-item' },
                { extend: 'csv', className: 'dropdown-item' },
                { extend: 'excel', className: 'dropdown-item' },
                { extend: 'pdf', className: 'dropdown-item' },
                { extend: 'print', className: 'dropdown-item' }
              ]
            },
            {
              extend: 'colvis',
              text: '<i class="fa fa-columns me-1"></i> Columns',
              className: 'btn btn-outline-dark btn-sm rounded-pill px-3 ms-2'
            }
          ],
          pageLength: 25,
          order: [[1, 'desc']], 
        });

        // Delegate event for View button
        $('#approvalsTable').off('click', '.btn-view-details').on('click', '.btn-view-details', (e) => {
          const id = $(e.currentTarget).data('id');
          const approval = this.approvals.find(a => a.id === id);
          if (approval) this.showModal(approval);
        });
      });
    },
    renderDuration(text) {
      let bg = '#f8f9fa';
      let color = '#6c757d';
      
      if (text.includes('day')) {
        const days = parseInt(text);
        if (days >= 5) {
          bg = '#ffe3e3';
          color = '#e03131';
        } else if (days >= 2) {
          bg = '#fff9db';
          color = '#f08c00';
        } else {
          bg = '#e7f5ff';
          color = '#1971c2';
        }
      } else {
        bg = '#ebfbee';
        color = '#2f9e44';
      }

      const style = `display: inline-flex; align-items: center; justify-content: center; padding: 4px 10px; border-radius: 20px; font-size: 10px; font-weight: 700; text-transform: uppercase; white-space: nowrap; line-height: 1; background: ${bg}; color: ${color}; border: 1px solid ${color}44;`;
      return `<span style="${style}">${text.toUpperCase()}</span>`;
    },
    renderStage(item) {
      let label = item.type || 'Pending';
      let bg = '#f8f9fa';
      let color = '#333';
      let border = '#dee2e6';

      const type = (item.type || '').toLowerCase();
      if (type === 'verify' || type === 'verification') {
        label = 'HOD';
        bg = '#eef2ff';
        color = '#4338ca';
        border = '#c7d2fe';
      } else if (type === 'stamp' || type === 'stamping' || type === 'verified') {
        label = 'Finance';
        bg = '#ecfdf5';
        color = '#047857';
        border = '#a7f3d0';
      } else if (type === 'ceo_stamp' || type === 'ceostamp' || type === 'ceo' || type === 'ceo_stamping') {
        label = 'CEO';
        bg = '#fff7ed';
        color = '#c2410c';
        border = '#fed7aa';
      }

      const stageStyle = `display: inline-flex; align-items: center; justify-content: center; padding: 2px 8px; border-radius: 10px; font-size: 10px; font-weight: 800; text-transform: uppercase; white-space: nowrap; line-height: 1; background: ${bg}; color: ${color}; border: 1px solid ${border};`;
      
      let html = `<div style="display: flex; align-items: center; flex-wrap: wrap; gap: 4px;">
                    <span style="${stageStyle}">${label.toUpperCase()}</span>`;

      if (item.potentialApprovers?.length) {
        html += `<span class="text-muted" style="font-size: 10px;">-</span>
                 <div class="d-flex flex-wrap gap-1">
                   ${item.potentialApprovers.map(name => `
                     <span class="badge bg-white text-dark border fw-normal" style="font-size: 0.62rem; border-color: #dee2e6 !important; border-radius: 6px; padding: 1px 4px; text-transform: uppercase;">${name}</span>
                   `).join('')}
                 </div>`;
      } else {
        html += `<span class="text-muted" style="font-size: 10px;">-</span>
                 <small class="text-muted" style="font-size: 0.62rem; text-transform: uppercase;">NONE</small>`;
      }
      
      html += `</div>`;
      return html;
    },
    renderPriority(p) {
      let bg = '#f8f9fa';
      let color = '#6c757d';
      if (p === 'urgent') { bg = '#ffe3e3'; color = '#c92a2a'; }
      else if (p === 'high') { bg = '#fff4e6'; color = '#d9480f'; }
      else { bg = '#e7f5ff'; color = '#1971c2'; }
      
      const style = `display: inline-flex; align-items: center; justify-content: center; padding: 4px 10px; border-radius: 20px; font-size: 10px; font-weight: 700; text-transform: uppercase; white-space: nowrap; line-height: 1; background: ${bg}; color: ${color}; border: 1px solid ${color}44;`;
      return `<span style="${style}">${(p || 'normal').toUpperCase()}</span>`;
    },
    formatModuleName(m) {
      if (!m) return '-';
      return m.replace(/_/g, ' ').replace(/-/g, ' ');
    },
    getReference(a) {
      if (a.module === 'purchase') return a.purchase?.purchaseNo || a.moduleId;
      if (a.module?.toLowerCase().includes('purchase_request')) return a.purchaseRequest?.purchaseRequestNo || a.moduleId;
      if (a.pickupNote) return a.pickupNote.pickupNo;
      if (a.dispatchNote) return a.dispatchNote.dispatchNo;
      return a.moduleId || '-';
    },
    async showModal(obj) {
      this.modalApproval = obj;
      if (obj.module?.toLowerCase().includes('purchase_request')) {
        try {
          const requestId = obj.purchaseRequestId || obj.moduleId;
          const res = await axios.get(`${process.env.VUE_APP_URL}/purchase-requests/${requestId}`, {
            headers: { Authorization: `Bearer ${this.token}` }
          });
          this.purchaseRequestDetails = res.data.data || res.data;
          this.showPurchaseRequestModal = true;
        } catch (e) {
          alert('Failed to load purchase request details');
        }
      } else {
        this.isModalVisible = true;
      }
    },
    getModalBody(approval) {
      if (!approval) return '';
      
      const type = (approval.type || '').toLowerCase();
      let displayStatus = approval.type || 'Pending';
      if (type === 'verify' || type === 'verification') displayStatus = 'HOD';
      else if (type === 'stamp' || type === 'stamping' || type === 'verified') displayStatus = 'FINANCE';
      else if (type === 'ceo_stamp' || type === 'ceostamp' || type === 'ceo' || type === 'ceo_stamping') displayStatus = 'CEO';

      const formatCurrency = (val) => {
        if (!val) return '-';
        return new Intl.NumberFormat('en-KE', { style: 'currency', currency: 'KES' }).format(val);
      };

      let tableRows = '';
      if (approval.module === 'purchase') {
        tableRows = `
          <tr><th class="bg-light" style="width: 35%;">Status</th><td class="fw-bold text-uppercase">${displayStatus}</td></tr>
          <tr><th class="bg-light">PO Number</th><td>${approval.purchase?.purchaseNo || '-'}</td></tr>
          <tr><th class="bg-light">Supplier</th><td>${approval.purchase?.Supplier?.name || '-'}</td></tr>
          <tr><th class="bg-light">Amount</th><td class="fw-bold text-primary">${formatCurrency(approval.purchase?.amount)}</td></tr>
          <tr><th class="bg-light">Created By</th><td>${approval.purchase?.User?.name || '-'}</td></tr>
        `;
      } else {
        tableRows = `<tr><th class="bg-light" style="width: 35%;">Module</th><td>${this.formatModuleName(approval.module)}</td></tr>
                     <tr><th class="bg-light">Stage</th><td class="fw-bold text-uppercase">${displayStatus}</td></tr>
                     <tr><th class="bg-light">Details</th><td>${approval.details || '-'}</td></tr>`;
      }

      let viewLink = '';
      if (approval.module === 'purchase' && approval.purchase?.id) {
        viewLink = `<div class="mt-2 text-center"><a class='btn btn-outline-primary btn-sm rounded-pill px-4' style="font-size: 11px;" href="/purchases/pdf/${approval.purchase.id}">View Full Purchase Order PDF</a></div>`;
      }

      return `
        <div class="table-responsive">
          <table class='table table-bordered mb-2 text-13'>
            ${tableRows}
          </table>
        </div>
        ${viewLink}
      `;
    },
    closeModal() {
      this.isModalVisible = false;
      this.showPurchaseRequestModal = false;
      this.purchaseRequestDetails = null;
    },
    formatDate(date, includeTime = false) {
      if (!date) return '-';
      const d = new Date(date);
      if (includeTime) return d.toLocaleString();
      return d.toLocaleDateString();
    }
  },
  mounted() {
    this.fetchAwaiting();
  },
  beforeUnmount() {
    if (this.dataTable) {
      this.dataTable.destroy();
    }
  }
}
</script>

<style scoped>
.transaction {
  padding-top: 10px;
}
.products-list {
  background: transparent;
  border-radius: 10px;
}
:deep(.dataTables_wrapper .dataTables_paginate .paginate_button) {
  padding: 0.2em 0.8em;
  font-size: 12px;
}
:deep(.dataTables_wrapper .dataTables_info) {
  font-size: 12px;
  padding-top: 1em;
}
:deep(.dataTables_wrapper .dataTables_filter input) {
  border: 1px solid #dee2e6;
  border-radius: 5px;
  padding: 4px 8px;
  font-size: 12px;
}

/* Skeleton Loader Styles */
.skeleton-table {
  width: 100%;
}
.skeleton-row {
  display: flex;
  gap: 15px;
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
}
.skeleton-cell {
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #f8f8f8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}
@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
</style>
